module.exports = __webpack_public_path__ + "img/Vangsgutane_Solveig_Muren_Sanden.62c92644.jpg";